// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom_container[data-v-15e70d26]{display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;border-radius:10px;border:1px solid var(--white-opacity-8);background:var(--white-opacity-2);font-family:Proxima Nova,sans-serif}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
